const EMAIL_REGEX = /^[A-Za-z0-9._%+-]{1,64}@[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,63}$/;

export function validateEmail(email: string) {
    if (!email) {
        return false;
    }

    return EMAIL_REGEX.test(email);
}
